/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  UpdateUserConfigSelfOptions,
  UpdateUserConfigSelfResponses,
} from '../types/UpdateUserConfigSelf'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Update user configuration for the authenticated user
 * {@link /v1/user/config/self}
 */
export function updateUserConfigSelf<ThrowOnError extends boolean = true>(
  options: Options<UpdateUserConfigSelfOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateUserConfigSelfResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/user/config/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateUserConfigSelfResponses, ThrowOnError>>,
  )
}
